module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/logo-coj-vi-797967f6aab15b3b980453613410ba0d.svg";